module.exports = __webpack_public_path__ + "img/project1.1e1f49b3.png";